import { httpClient } from "../http/httpClient"

export interface CreateCltTransactionBody {
  linkName: string
  customerId: string
  tableCode: string
  value: number
  Prazo: number
  codigoTabela: number
  codigoProduto: number
  codigoEmpregador: number
  codigoOrgao: number
  valorParcela: number
  taxa: number
  matricula: number
  cnpjEmpresa: string
}

export interface CreateCltTransactionResponse {
  _id: string
  contract?: string
  value: number
  status: string
  seller: string
  customer: string
  type: string
  createdAt: string
  updatedAt: string
}

export async function createCltTransaction(
  body: CreateCltTransactionBody,
): Promise<CreateCltTransactionResponse> {
  const {
    linkName,
    customerId,
    value,
    Prazo,
    codigoTabela,
    codigoProduto,
    codigoEmpregador,
    codigoOrgao,
    valorParcela,
    taxa,
    matricula,
    cnpjEmpresa,
    tableCode,
  } = body

  const { data } = await httpClient
    .post<CreateCltTransactionResponse>(
      `/self-hire/${linkName}/transaction`,
      {
        type: "CLT",
        value,
        customerId,
        providerData: {
          Prazo,
          codigoTabela,
          codigoProduto,
          codigoEmpregador,
          codigoOrgao,
          valorParcela,
          taxa,
          matricula,
          cnpjEmpresa,
          tableCode,
        },
      },
    )
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
